<template>
  <div>
    Enter product dimensions:
    <label v-for="dimension in value" :key="dimension.name">
      <dimension-value v-model="dimension.value" :name="dimension.name" />
      <dimension-unit v-model="dimension.unit" />
      <dimension-inches
        v-model="dimension.inches"
        :dimension-value="dimension.value"
        :dimension-unit="dimension.unit"
      />
      <dimension-tolerance
        v-model="dimension.tolerance"
        :dimension-name="dimension.name"
        :dimension-value="dimensionValueForTolerance(dimension)"
        :product-name="productName"
        :tolerances-enabled="tolerancesEnabled"
      />
    </label>
  </div>
</template>

<script>
import DimensionInches from "./Dimension/DimensionInches.vue";
import DimensionTolerance from "./Dimension/DimensionTolerance.vue";
import DimensionUnit from "./Dimension/DimensionUnit.vue";
import DimensionValue from "./Dimension/DimensionValue.vue";

export default {
  components: {
    DimensionInches,
    DimensionTolerance,
    DimensionUnit,
    DimensionValue
  },
  props: {
    productName: {
      type: String,
      default: ""
    },
    lengthToleranceDimension: {
      type: String,
      default: ""
    },
    tolerancesEnabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: null
    }
  },
  methods: {
    dimensionValueForTolerance(dimension) {
      if (this.lengthToleranceDimension === "") {
        return dimension.inches;
      }

      if (dimension.name === "Length" || dimension.name === "Width") {
        return this.value[this.lengthToleranceDimension].inches;
      } else {
        return dimension.inches;
      }
    }
  }
};
</script>
